// extracted by mini-css-extract-plugin
module.exports = {"map-placeholder":"_8c559fa4c7--map-placeholder--hACLB","is-open":"_8c559fa4c7--is-open--CZR1m"};